import { useSimpleRequest } from "hooks/useRequest";
import { ResendPreapplicationVerifyLink } from "features/ecommerce/types";
import { resendPreapplicationVerifyLink } from "features/ecommerce/api";

export default function useResendLink() {

    const request = useSimpleRequest({
        shouldNotifyOnSuccess: true
    });

    const resendLink = (body: ResendPreapplicationVerifyLink) => (
        request(() => resendPreapplicationVerifyLink(body))
    );


    return {
        resendLink,
    };
};